export default "__VITE_ASSET__DjQNddss__"